export type TimeAgoUnit = 'just_now' | 'seconds' | 'minutes' | 'hours' | 'days';

export interface TimeAgo {
  unit: TimeAgoUnit;
  count: number;
}

const JUST_NOW_THRESHOLD_SEC = 5;
const SECONDS_IN_MINUTE = 60;
const MINUTES_IN_HOUR = 60;
const HOURS_IN_DAY = 24;

export const computeTimeAgo = (isoDate: string): TimeAgo => {
  const diffMs = Date.now() - new Date(isoDate).getTime();
  const diffSec = Math.max(0, Math.floor(diffMs / 1000));

  if (diffSec < JUST_NOW_THRESHOLD_SEC) return { unit: 'just_now', count: 0 };
  if (diffSec < SECONDS_IN_MINUTE) return { unit: 'seconds', count: diffSec };

  const diffMin = Math.floor(diffSec / SECONDS_IN_MINUTE);
  if (diffMin < MINUTES_IN_HOUR) return { unit: 'minutes', count: diffMin };

  const diffHours = Math.floor(diffMin / MINUTES_IN_HOUR);
  if (diffHours < HOURS_IN_DAY) return { unit: 'hours', count: diffHours };

  return { unit: 'days', count: Math.floor(diffHours / HOURS_IN_DAY) };
};
